export const loginWhiteList = [
  'pages/index',
  'pages/mini-index',
  'pages/category',
];
